import React, { useEffect, useRef, useState } from 'react'

import CSSTransition from 'react-transition-group/CSSTransition'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import styles from './styles.module.scss'

import PropTypes from 'prop-types'

import { useDispatch, useSelector } from 'react-redux'
import { userLogout } from '../../redux/actions/auth'
import { getAuthMe, getCv } from '../../api/getApi'
import { Link, useLocation } from 'react-router-dom'
import Spinner from '../../UI/Spinner/Spinner'
import { SPINNER_TYPE } from '../../UI/Spinner/useSpinnerElement'
import Button from '../../UI/Button/Button'
import { profilePaths } from '../../constants/constans'
import { notify } from '../../helpers/notify'
import { trackSignOut } from '../../utils/gtm'
import CompletionStatus from '../CompletionStatus/CompletionStatus'
import CvForm from '../Form/CvForm/CvForm'
import Portal from '../Portal/Portal'

const UserProfileMore = ({ isAdmin }) => {
  const { picture, first_name: firstName, last_name: lastName, email, last_login, filler } = useSelector(
    ({ user }) => user.profile
  )
  const { scope } = useSelector(({ authentication }) => authentication.user)

  const [lastLogin, setLastLogin] = useState(last_login) // eslint-disable-line no-unused-vars -- for Last session when uncommented
  const [cvLoading, setCvLoading] = useState(false)
  const [isOpenCvForm, setIsOpenCvForm] = useState(false)
  const cvFormNodeRef = useRef(null)

  const dispatch = useDispatch()

  const popup = useRef(null)

  const location = useLocation()

  const isSeafarer = scope === 'seafarer'
  const isProfile = location.pathname.includes('/profile')
  const hasCv = filler?.grand_total > 0

  const logOut = () => {
    trackSignOut()
    dispatch(userLogout())
  }

  useEffect(() => {
    const getMe = async () => {
      try {
        const response = await getAuthMe(scope)

        setLastLogin(response.last_login)
      } catch (error) {
        notify.errorsList(error.errors)
      }
    }

    if (scope) getMe()

    return () => {
      setLastLogin('loading...')
    }
  }, [scope])

  const handleExportClick = () => {
    setCvLoading(true)

    const getCvSeafarer = async () => {
      try {
        const response = await getCv()

        setCvLoading(false)

        const file = window.URL.createObjectURL(response)
        const anchor = document.createElement('a')

        anchor.download = `${lastName}_CV.pdf`
        anchor.href = file
        anchor.click()
      } catch (error) {
        setCvLoading(false)
        notify.errorsList(error.errors)
      }
    }

    getCvSeafarer()
  }

  useEffect(() => {
    const body = document.body

    isOpenCvForm ? disableBodyScroll(body) : enableBodyScroll(body)

    return () => enableBodyScroll(body)
  }, [isOpenCvForm])

  return (
    <div ref={popup} className={styles.more}>
      <div className={styles.more_header}>
        {picture && <img src={picture.file_mini || picture.file} alt='user profile' />}

        <div className={styles.more_header_info}>
          <div className={styles.more_username}>
            {firstName} {lastName}
          </div>

          <div className={styles.more_email}> {email} </div>
        </div>
      </div>

      <div className={styles.more_header_complete_status}>
        <CompletionStatus value={filler.grand_total} color={filler.color} unfilled={filler.unfilled} />
      </div>

      <div className={styles.content}>
        <div className={styles.buttons}>
          <Link to={isProfile ? '/' : profilePaths.personal_data}>
            <Button disabled={isAdmin} size='middle-full'>
              {isProfile ? 'Main page' : 'Go to profile'}
            </Button>
          </Link>
        </div>

        {isSeafarer && (
          <div className={styles.buttons}>
            {/* Send CV button temporarily hidden
            <button
              className={styles.buttons_cv}
              onClick={(e) => {
                e.stopPropagation()
                setIsOpenCvForm(true)
              }}
            >
              Send CV
            </button>
            */}
            <button
              disabled={!hasCv || cvLoading}
              onClick={handleExportClick}
              className={styles.buttons_cv}
              style={cvLoading ? { minHeight: 40, width: '100%' } : { width: '100%' }}
            >
              {cvLoading ? <Spinner type={SPINNER_TYPE.SPINNER} size={20} color='var(--color-accent-light)' /> : 'Export CV'}
            </button>
          </div>
        )}

        <div className={styles['button-logout']}>
          <Button type='button' theme='text' onClick={logOut} style={{ width: '100%' }}>
            Sign out
          </Button>
        </div>

        {/* <div className={styles.more_footer}>Last session: {lastLogin}</div> */}
      </div>

      {isOpenCvForm && (
        <Portal>
          <div style={{ position: 'fixed', inset: 0, zIndex: 1300 }}>
            <CSSTransition nodeRef={cvFormNodeRef} classNames='fadein-top' appear in={true} timeout={300}>
              <div ref={cvFormNodeRef}>
                <CvForm setIsOpen={setIsOpenCvForm} />
              </div>
            </CSSTransition>
          </div>
        </Portal>
      )}
    </div>
  )
}

UserProfileMore.propTypes = {
  first_name: PropTypes.string,
  last_name: PropTypes.string,
  email: PropTypes.string,
}

export default UserProfileMore
